import Big from 'big.js';
import { Packery } from 'packery';
import axios from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as models from 'smg/customer-api/models';
import { ReportValidity } from 'smg/form';
import * as toast from 'smg/toast';
import * as uploads from 'smg/uploads';
import { DollarFormat } from 'smg/util';
import * as carts from '../carts';

declare interface myWindow extends Window {
    readonly frontUrl: string;
    readonly frontBlueUrl: string;
}
declare const window: myWindow;

declare interface file {
    uploadID: number;
    url: string;
    name: string;
    mime: string;
}

void main();

async function main() {
    // SVG
    const svgContainer = document.querySelector('#svg-container') as HTMLElement;
    const coinBack = document.querySelector('#coin-back') as SVGElement;

    // CONTAINERS
    const thumbnailsContainer = document.querySelector('#seal-uploads-thumbnails') as HTMLElement;
    const uploaderContainer = document.querySelector('#seal-uploads') as HTMLLabelElement;

    // BUTTONS
    const chooseQtyBtn = document.querySelector('#qty-info-icon') as HTMLAnchorElement;
    const addToCartBtn = document.querySelector('#add-to-cart-btn') as HTMLButtonElement;

    // FRONT INPUTS
    const frontTop = document.querySelector('#front-top-message') as HTMLInputElement;
    const frontBottom = document.querySelector('#front-bottom-message') as HTMLInputElement;
    const blueLine = document.querySelector('#blue-line') as HTMLInputElement;

    // BACK INPUTS
    const backTop = document.querySelector('#back-top-message') as HTMLInputElement;
    const backBottom = document.querySelector('#back-bottom-message') as HTMLInputElement;

    // ACCORDION
    const accordionListenerEl = document.querySelector('#flush-collapseOne') as HTMLElement;

    // BADGE INPUTS
    const badgeSlotOne = document.querySelector('#badge-top-message') as HTMLInputElement;
    const badgeSlotTwo = document.querySelector('#badge-second-message') as HTMLInputElement;
    const badgeSlotThree = document.querySelector('#badge-third-message') as HTMLInputElement;
    const badgeSlotFour = document.querySelector('#badge-fourth-message') as HTMLInputElement;
    const defaultSeal = document.querySelector('#default-seal') as HTMLInputElement;

    // QUANTITY/PRICE
    const qtyNumber = document.querySelector('#qty-number') as HTMLInputElement;
    const qtyPrice = document.querySelector('#qty-price') as HTMLElement;

    // GET STOCK ITEM
    const stockItemID = 'Ee3fpSxnK4a4sAJCrBIABA';
    const stockItemsResp = await axios.get('/stock-items', {
        params: {
            'q': `id:${stockItemID}`,
        },
    });
    const stockItem = models.StockItemsHyejooResponse.fromJSON(stockItemsResp.data).stockItems[0];

    // BUTTON EVENT LISTENERS
    blueLine.addEventListener('click', () => {
        const imgTag = document.querySelector('#side-one-svg') as HTMLImageElement;
        if (blueLine.checked) {
            imgTag.setAttributeNS('http://www.w3.org/1999/xlink', 'href', window.frontBlueUrl);
        } else {
            imgTag.setAttributeNS('http://www.w3.org/1999/xlink', 'href', window.frontUrl);
        }
    });

    // INPUT EVENT LISTENERS
    frontTop.addEventListener('input', () => {
        const output = document.querySelector('#coin-front #top-text') as HTMLElement;
        output.textContent = frontTop.value;
    });
    frontTop.dispatchEvent(new Event('input'));

    frontBottom.addEventListener('input', () => {
        const output = document.querySelector('#coin-front #bottom-text') as HTMLElement;
        output.textContent = frontBottom.value;
    });
    frontBottom.dispatchEvent(new Event('input'));

    backTop.addEventListener('input', () => {
        const output = document.querySelector('#coin-back #top-text') as HTMLElement;
        output.textContent = backTop.value;
    });
    backTop.dispatchEvent(new Event('input'));

    backBottom.addEventListener('input', () => {
        const output = document.querySelector('#coin-back #bottom-text') as HTMLElement;
        output.textContent = backBottom.value;
    });
    backBottom.dispatchEvent(new Event('input'));

    // FIRST ROCKER
    let firstRockerEdited = false;
    const outputBadgeOne = document.querySelector('#badge-top') as HTMLElement;
    badgeSlotOne.addEventListener('keyup', () => {
        firstRockerEdited = true;
    });
    badgeSlotOne.addEventListener('input', () => {
        outputBadgeOne.textContent = badgeSlotOne.value;
    });
    badgeSlotOne.dispatchEvent(new Event('input'));

    // SECOND ROCKER
    let secondRockerEdited = false;
    const outputBadgeTwo = document.querySelector('#badge-top-second') as HTMLElement;
    badgeSlotTwo.addEventListener('keyup', () => {
        secondRockerEdited = true;
    });
    badgeSlotTwo.addEventListener('input', () => {
        outputBadgeTwo.textContent = badgeSlotTwo.value;
    });
    badgeSlotTwo.dispatchEvent(new Event('input'));

    // THIRD ROCKER
    let thirdRockerEdited = false;
    const outputBadgeThree = document.querySelector('#badge-under-seal') as HTMLElement;
    badgeSlotThree.addEventListener('keyup', () => {
        thirdRockerEdited = true;
    });
    badgeSlotThree.addEventListener('input', () => {
        outputBadgeThree.textContent = badgeSlotThree.value;
    });
    badgeSlotThree.dispatchEvent(new Event('input'));

    // FOURTH ROCKER
    let fourthRockerEdited = false;
    const outputBadgeFour = document.querySelector('#badge-under-seal-second') as HTMLElement;
    badgeSlotFour.addEventListener('keyup', () => {
        fourthRockerEdited = true;
    });
    badgeSlotFour.addEventListener('input', () => {
        outputBadgeFour.textContent = badgeSlotFour.value;
    });
    badgeSlotFour.dispatchEvent(new Event('input'));

    // ACCORDION LISTENER
    const centerSeal = document.querySelector('#center-seal') as HTMLElement;
    accordionListenerEl.addEventListener('show.bs.collapse', () => {
        svgContainer.classList.add('flex-column');
        svgContainer.classList.remove('flex-sm-row');
        svgContainer.classList.add('align-items-center');
        if (thumbnailsContainer.firstElementChild) {
            uploaderContainer.classList.add('d-none');
            centerSeal.classList.add('d-none');
        } else {
            uploaderContainer.classList.remove('d-none');
            centerSeal.classList.remove('d-none');
        }
        badgeSlotOne.value = badgeSlotOne.value || '1ST ROCKER';
        badgeSlotOne.dispatchEvent(new Event('input'));
        badgeSlotTwo.value = badgeSlotTwo.value || '2ND ROCKER';
        badgeSlotTwo.dispatchEvent(new Event('input'));
        badgeSlotThree.value = badgeSlotThree.value || '3RD ROCKER';
        badgeSlotThree.dispatchEvent(new Event('input'));
        badgeSlotFour.value = badgeSlotFour.value || 'FL';
        badgeSlotFour.dispatchEvent(new Event('input'));
    });
    accordionListenerEl.addEventListener('hide.bs.collapse', () => {
        if (defaultSeal.value) {
            centerSeal.classList.remove('d-none');
        } else {
            centerSeal.classList.add('d-none');
        }
        if (!firstRockerEdited) {
            badgeSlotOne.value = '';
            outputBadgeOne.textContent = '';
        }
        if (!secondRockerEdited) {
            badgeSlotTwo.value = '';
            outputBadgeTwo.textContent = '';
        }
        if (!thirdRockerEdited) {
            badgeSlotThree.value = '';
            outputBadgeThree.textContent = '';
        }
        if (!fourthRockerEdited) {
            badgeSlotFour.value = '';
            outputBadgeFour.textContent = '';
        }
        coinBack.classList.remove('mt-20');
        svgContainer.classList.add('flex-sm-row');
        uploaderContainer.classList.remove('d-none');
        defaultSealContainer.classList.remove('d-none');
        uploadID = undefined;
    });

    // UPLOADER
    const uploadsLabel = document.querySelector('#seal-uploads') as HTMLLabelElement;
    const u = new uploads.Uploader(uploadsLabel, {
        confirmBtn: addToCartBtn,
    });
    let uploadID: number | undefined;
    // EVENT LISTENER/SET CENTER SEAL IMG
    const defaultSealContainer = document.querySelector('#default-seal-container') as HTMLElement;
    const centerSealImg = document.querySelector('#seal-upload-img') as HTMLAnchorElement;
    u.onUpload = (f: file, thumb: HTMLElement) => {
        uploaderContainer.classList.add('d-none');
        defaultSealContainer.classList.add('d-none');
        centerSealImg.classList.remove('d-none');
        uploadID = f.uploadID;
        thumbnailsContainer.innerHTML = '';
        thumbnailsContainer.appendChild(thumb);

        (centerSealImg.href as unknown as SVGAnimatedString).baseVal = (thumb.lastElementChild as HTMLImageElement).src;
        centerSeal.classList.add('d-none');

        const removeThumb = thumb.querySelector('.upload-thumbnail-close') as HTMLElement;
        removeThumb.addEventListener('click', () => {
            uploaderContainer.classList.remove('d-none');
            defaultSealContainer.classList.remove('d-none');
            centerSealImg.classList.add('d-none');
            centerSeal.classList.remove('d-none');
            uploadID = undefined;
        });
    };

    // CALCULATE PRICE
    const calculatePrice = (selectedQty: number): Big => {
        interface quantityPrice {
            qty: number;
            price: Big;
        }
        const qtyPrices: quantityPrice[] = [];
        for (const [qtyKey, price] of stockItem.quantityPricing) {
            qtyPrices.push({
                qty: qtyKey,
                price,
            });
        }
        qtyPrices.sort((a, b) => b.qty - a.qty);
        let price = Big(0);
        for (const qp of qtyPrices) {
            if (selectedQty >= qp.qty) {
                price = qp.price;
                break;
            }
        }
        return price.mul(selectedQty || 0);
    };

    const quantityTiers = (): carts.QuantityTier[] =>
        [...stockItem.quantityPricing.entries()].map(([quantity, unitPrice]) => ({ quantity, unitPrice, fixedPrice: Big(0) }));

    // CHOOSE QUANTITY EVENT LISTENER
    let qty = 1;
    qtyNumber.value = String(qty);
    qtyPrice.textContent = DollarFormat(calculatePrice(qty));
    qtyNumber.addEventListener('input', () => {
        qty = parseInt(qtyNumber.value, 10);
        qtyPrice.textContent = DollarFormat(calculatePrice(qty));
    });
    chooseQtyBtn.addEventListener('click', async () => {
        await carts.PromptQuantityEdit(qty, quantityTiers()).then(res => {
            qty = res;
            qtyNumber.value = String(qty);
            qtyPrice.textContent = DollarFormat(calculatePrice(qty));
        });
    });

    // ADD TO CART EVENT LISTENER
    addToCartBtn.addEventListener('click', async () => {
        if (qty < 1) {
            qtyNumber.setCustomValidity(' ');
            ReportValidity(qtyNumber);
            toast.Error('Please enter a valid quantity!');
            return;
        }
        buttons.Start(addToCartBtn);
        await carts.AddCartItem(
            {
                stockItemID: stockItemID,
                quantity: qty,
                customizations: {
                    '01. Front Top Text': frontTop.value,
                    '02. Front Bottom Text': frontBottom.value,
                    '03. Thin Blue Line': blueLine.checked ? 'Yes' : 'No',
                    '04. Back Top Text': backTop.value,
                    '05. Back Bottom Text': backBottom.value,
                    '06. Top Rocker': badgeSlotOne.value,
                    '07. Middle Rocker': badgeSlotTwo.value,
                    '08. Bottom Rocker': badgeSlotThree.value,
                    '09. State': badgeSlotFour.value,
                    ...defaultSeal.value ? { '10. Custom Seal: State/City': defaultSeal.value } : {},
                },
                cartItemUploadIDs: uploadID ? [uploadID] : undefined,
            },
        ).finally(() => buttons.Stop(addToCartBtn));
    });

    const coinContainer = document.querySelector('#coin-container') as HTMLElement;
    const packery = new Packery(coinContainer, {
        itemSelector: '.grid-item',
        gutter: 0,
        transitionDuration: 0,
    });

    accordionListenerEl.addEventListener('shown.bs.collapse', () => packery.layout());
    accordionListenerEl.addEventListener('hidden.bs.collapse', () => packery.layout());
}
